export default "__VITE_ASSET__DrUB$u4$__"